module.exports = __webpack_public_path__ + "static/media/Metaspeed-ASICS-Lab.3cf26b5f.png";